import React from 'react';
import './edu.scss';

const context = {
  ru: {
    title: 'Образование',
    str1: {
      title: 'Самообразование',
      text: 'С момента рождения по настоящее время',
    },
    str2: {
      title: 'RSSchool Курс «JavaScript/Front-end»',
      text: 'Сентябрь 2018 - Март 2019',
    },
    str3: {
      title: 'Высший колледж связи. Телевидение.',
      text: 'Окончил в 2001 г.',
    },
  },
  en: {
    title: 'Education',
    str1: {
      title: 'Self-education',
      text: 'From birthday to present day',
    },
    str2: {
      title: 'RSSchool - «JavaScript/Front-end»',
      text: 'September, 2018 - March, 2019',
    },
    str3: {
      title: 'Higher College of Communication. A Television.',
      text: 'Graduated in 2001',
    },
  },
};

const Edu = ({ lang }) => {
  const { title, str1, str2, str3 } = context[lang];
  return (
    <div className="Edu">
      <hr />
      <h4>{title}</h4>
      <hr />
      <table>
        <tbody>
          <tr>
            <td>{str1.title}</td>
            <td>{str1.text}</td>
          </tr>
          <tr>
            <td>{str2.title}</td>
            <td>{str2.text}</td>
          </tr>
          <tr>
            <td>{str3.title}</td>
            <td>{str3.text}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Edu;
